<template>
  <div class="h-screen" :class="[`bg-${$route.meta.background}`]">
    <eggos
      v-if="$route.meta.eggos !== undefined"
      :color="$route.meta.eggos"
    ></eggos>
    <Preloader v-if="isLoading" />
    <div class="regulations">
      <div class="regulations__arrow">
        <button @click="$router.go(-1)">
          <img class="arrow" src="@/assets/images/icons/right-arrow.svg" />
        </button>
      </div>
      <div class="regulations__logo">
        <img src="@/assets/images/brand/logo.svg" />
      </div>
      <div class="regulations__content">
       <transition name="page" mode="out-in">
        <router-view></router-view>
      </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Preloader from '@/components/Preloader.vue';
import Eggos from '../components/Eggos.vue';

export default {
  name: 'RegulationsLayout',

  components: {
    Eggos,
    Preloader,
  },

  computed: {
    ...mapState('layout', ['isLoading']),

  },

  created() {
    this.$store.commit('layout/startLoading');
  },

  mounted() {
    setTimeout(() => {
      this.$store.commit('layout/finishLoading');
    }, 500);
  },
};
</script>

<style lang="scss" scoped>

.regulations {
  @apply relative z-10 mx-auto;
  max-width: 500px;
  height: 100vh;
  @media screen and (min-width: 768px) {
    @apply justify-around;
    max-width: 900px;
  }
  &__logo {
    @apply pt-6;
    padding-bottom: 28px;
    padding-top: 44px;
    @media screen and (min-width: 1600px) {
      @apply pt-12;
    }
    img {
      @apply block mx-auto;
      width: 56px;
    }
  }
  &__content {
    @apply px-3;
  }
  &__arrow {
    @apply mt-3 mb-8 absolute;
    left: 16px;
    top: 24px;
    transition: transform 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
    @media screen and (min-width: 768px) {
      left: 0;
    }
    img {
      @apply py-6;
      @media screen and (min-width: 768px) {
        @apply p-6;
      }
    }
  }
}

</style>
